module.exports = __webpack_public_path__ + "static/media/news2.9454eabf.png";